module.exports = __webpack_public_path__ + "img/DE.079b8347.svg";